export const TemplateMessages = {
  list: 'Template List',
  welcome:
    'Welcome to CloudVOTE. Please view templates or join an existing, live poll.',
  footer: 'Copyright © 2021 - Meridia Interactive Solutions',
  defaultLoading: 'Loading',
  generatingPollingReport: 'Generating polling session report',
  generatingChart: 'Generating graph',
}
